import { Injectable } from '@angular/core';
import { RequestBase } from './request-base';
import { Observable } from 'rxjs';

@Injectable()
export class ConfigService extends RequestBase {
    BasePath = 'config/api/config/';

    GetSelectedLanguages(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + 'GetSelectedLanguages', this.options);
    }

    GetLanguageSettings(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + 'GetLanguageSettings', this.options);
    }

    SaveLanguageSettings(settings): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + 'SaveLanguageSettings', settings, this.options);
    }

    GetManagementStatus(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + 'GetManagementStatus', this.options);
    }

    GetConfigProperties(query): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + 'GetConfigProperties', query, this.options);
    }
}
